export default __webpack_public_path__ + "src/assets/gol-logo.0fa8e69e7b586f18532a528829e062dd.png";